export const ListQueryKey = 'boats';
export const DetailQueryKey = 'boat';

export const Urls = {
  selectUrl: '/boat/list',
  updateUrl: '/boat/update',
  deleteUrl: '/boat/delete',
  createUrl: '/boat/create',
  detailUrl: '/boat/info',
};
